import { useMemo, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetTicketListGlobal } from "@type/api/management";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import {
  TGetTicketListGlobalReq,
  TGetTicketListGlobalRes,
} from "@type/api/management/types";

interface UseGetTicketListGlobalOptionsProps {
  idPipeline?: string;
  onSuccess?: (res: TGetTicketListGlobalRes) => void;
}

export const UseGetTicketListGlobalOptions = ({
  idPipeline,
  onSuccess,
}: UseGetTicketListGlobalOptionsProps) => {
  const [ticketListGlobalOptions, setTicketListGlobalOptions] = useState<
    TInputTag[]
  >([]);

  const [data, setData] = useState({ page: 1, pageSize: 50, filter: {} });

  const params: TGetTicketListGlobalReq = useMemo(
    () => ({
      data: {
        ...data,
        filter: {
          ...data.filter,
          idPipeline,
        },
      },
    }),
    [data, idPipeline]
  );

  const queryGetTicketListGlobalKey = useMemo(() => {
    return queryGetTicketListGlobal._key(params);
  }, [params]);

  const { isLoading: isLoadingGetTicketListGlobalOptions } =
    useQueryWithCallbacks({
      queryKey: queryGetTicketListGlobalKey,
      enabled: !!idPipeline,
      queryFn: () => queryGetTicketListGlobal(params),
      onSuccess: (res) => {
        const data = res?.data ?? [];

        const newOptions: TInputTag[] = data.map(({ id, title, code }) => ({
          id,
          name: `${code} ${title}`,
        }));
        setTicketListGlobalOptions((prev) => [...prev, ...newOptions]);
        if (newOptions.length > 0) {
          setData((prev) => ({ ...prev, page: prev.page + 1 }));
        }

        onSuccess?.(res);
      },
    });

  return {
    ticketListGlobalOptions,
    queryGetTicketListGlobalKey,
    isLoadingGetTicketListGlobalOptions,
  };
};
